export const GA_CLICK_ACTION = {
  EXPORT_EXCEL: 'EXPORT_EXCEL',
  UNSALE_DROPDOWN: 'UNSALE_DROPDOWN',
  PAGINATION: 'PAGINATION',
  SHOW_PAGES: 'SHOW_PAGES'
}

const GA_KEY = {
  EXPORT_EXCEL: 'EXPORT_EXCEL',
  UNSALE_DROPDOWN: 'UNSALE_DROPDOWN',
  PAGINATION: 'PAGINATION',
  SHOW_PAGES: 'SHOW_PAGES'
}

const GA_KEY_MAP = {
  [GA_KEY.EXPORT_EXCEL]: 'wh_unsale_list_downloadfile',
  [GA_KEY.UNSALE_DROPDOWN]: 'wh_unsale_list_dropdownmenu',
  [GA_KEY.PAGINATION]: 'wh_unsale_list_pages',
  [GA_KEY.SHOW_PAGES]: 'wh_unsale_list_showpages'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.EXPORT_EXCEL:
    case GA_CLICK_ACTION.UNSALE_DROPDOWN:
    case GA_CLICK_ACTION.PAGINATION:
    case GA_CLICK_ACTION.SHOW_PAGES:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    category: 'warehouse',
    action: 'wh_unsalableItems',
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
